import type { TypographyProps } from '@mui/material/Typography';

export const moreInformationTypographyProps: TypographyProps = {
  variant: 'body2',
  paragraph: true,
};
